import {
  GET_ALL_EVENTS,
  SET_SINGLE_EVENT,
  REMOVE_SINGLE_EVENT,
  SET_SINGLE_SECTION,
  ADD_EVENT_SECTION,
  SET_EVENT_SECTIONS,
  REMOVE_EVENT_SECTION,
  SET_SECTION_TICKETS,
  REMOVE_SECTION_TICKET,
  SET_EVET_TICKET_TOKEN_LIST,
  SET_SINGLE_WGEVENT,
  GET_ACTIVE_WGEVENT,
} from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
  allEvents: [],
  eventSecitons: [],
  singleEvent: null,
  singleSeciton: null,
  singleWGEvent: null,
  activeWGEvent: [],
  sectionTickets: [],
  eventTicketTokenList: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ALL_EVENTS: {
      return {
        ...state,
        allEvents: action.payload,
      };
    }
    case SET_SINGLE_EVENT: {
      return {
        ...state,
        singleEvent: action.payload,
      };
    }
    case SET_SINGLE_SECTION: {
      return {
        ...state,
        singleSeciton: action.payload,
      };
    }
    case SET_EVENT_SECTIONS: {
      return {
        ...state,
        eventSecitons: action.payload,
      };
    }
    case REMOVE_SINGLE_EVENT: {
      return {
        ...state,
        allEvents: state.allEvents.filter(
          (item) => (item._id || item.id) !== action.payload
        ),
      };
    }
    case REMOVE_EVENT_SECTION: {
      return {
        ...state,
        eventSecitons: state.eventSecitons.filter(
          (item) => (item._id || item.id) !== action.payload
        ),
      };
    }
    case ADD_EVENT_SECTION: {
      return {
        ...state,
        eventSecitons: [action.payload, ...state.eventSecitons],
      };
    }
    case SET_SECTION_TICKETS: {
      return {
        ...state,
        sectionTickets: action.payload,
      };
    }
    case SET_EVET_TICKET_TOKEN_LIST: {
      return {
        ...state,
        eventTicketTokenList: action.payload,
      };
    }
    case REMOVE_SECTION_TICKET: {
      console.log(action.payload, "[reducer]");
      return {
        ...state,
        sectionTickets: state.sectionTickets.filter(
          (item) => (item._id || item.id) !== action.payload
        ),
      };
    }
    case SET_SINGLE_WGEVENT: {
      return {
        ...state,
        singleWGEvent: action.payload,
      };
    }
    case GET_ACTIVE_WGEVENT: {
      return {
        ...state,
        activeWGEvent: action.payload,
      };
    }
    default:
      return state;
  }
};
